import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section id="topics" className="bg-primary-950">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-5 flex items-end justify-between gap-4 md:mb-6">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-background-50 md:text-2xl">
              <span className="h-5 w-1 rounded-full bg-accent-500 md:h-6"></span>
              影视专题推荐
            </h2>
            <p className="mt-1.5 text-xs text-background-100/70 md:text-sm">
              精选主题策划，带你发现更多值得一看的好故事
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to="/category"
              className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-lg border border-background-50/10 md:h-64"
            >
              <img
                src={topic.cover}
                alt={`${topic.title}专题封面`}
                title={`${topic.title} - 色色影院影视专题`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/40 to-transparent"></div>
              <div className="relative z-10 p-4 md:p-5">
                <span
                  className={`inline-block rounded-md px-2 py-0.5 text-[11px] font-semibold ${
                    topic.accent
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-50/15 text-background-50"
                  }`}
                >
                  {topic.count} 部作品
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold text-background-50">
                  {topic.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs text-background-100/75">
                  {topic.subtitle}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}